import axios from 'api';

export const getRoles = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/core/groups/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const createRole = (roleData) => {
  return axios.post(`api/core/groups/`, roleData);
};

export const updateRole = (roleData) => {
  return axios.put(`api/core/groups/${roleData.id}/`, roleData);
};

export const deleteRole = (id) => {
  return axios.delete(`api/core/groups/${id}/`);
};

export const getPermissionsData = async ({ search, id }) => {
  return axios.get(`api/core/permission_status/?get_all=true&group__id=${id}&search=${search}`);
};

export const updatePermissionsData = async (params) => {
  return axios.put(`api/core/permission_status/update_bulk_permissions/`, { data: params });
};
